/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

/**
 * Formats a Date as a local-time ISO date string (YYYY-MM-DD).
 */
export function toIsoDate(date: Date): string {
  const year = date.getFullYear()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * Returns today's date (local time) as an ISO date string (YYYY-MM-DD).
 */
export function todayIso(): string {
  return toIsoDate(new Date())
}

/**
 * Returns the date `years` years before today (local time) as an ISO date string (YYYY-MM-DD).
 */
export function isoYearsAgo(years: number): string {
  const date = new Date()
  date.setFullYear(date.getFullYear() - years)
  return toIsoDate(date)
}

/**
 * Converts an ISO date string (YYYY-MM-DD) to the compact form YYYYMMDD.
 */
export function isoToCompact(isoDate: string): string {
  return isoDate.replace(/-/g, '')
}
